import { render, staticRenderFns } from "./ExhibitionsPage.vue?vue&type=template&id=ee4708b8&scoped=true&"
import script from "./ExhibitionsPage.vue?vue&type=script&lang=js&"
export * from "./ExhibitionsPage.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionsPage.vue?vue&type=style&index=0&id=ee4708b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4708b8",
  null
  
)

export default component.exports